module.exports = __webpack_public_path__ + "static/media/location.c4ed52dd.svg";